import React, { useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography, Tooltip, IconButton } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import RaspberryEraseStationDebugLogsList from './RaspberryEraseStationDebugLogsList';
import { hasPermission, formatDate } from '../../../sc-utilities';
import config from "../../../../config/config";
import { download } from '../../../sc-utilities/download.utils';
import { snackActions } from "../../../sc-utilities/SnackBar";

const styles = theme => ({
    "@global": {
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: 'none',
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        "[class*='active']": {
            color: theme.palette.success.dark
        },
        "[class*='inactive']": {
            color: theme.palette.error.dark
        }
    },
    root: {
        width: '100%',
        height: "auto",
        paddingLeft: theme.spacing(-1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    active: {
        color: theme.palette.success.dark
    },
    inactive: {
        color: theme.palette.error.dark
    },
    remote: {
        textDecoration: 'none',
        color: 'white'
    }
})

const RaspberryEraseStationDebugLogs = props => {
    const tableRef = useRef();
    const { columns, classes, translations, permissions, activeCustomerID } = props;
    const visible = columns && columns['RaspberryEraseStationDebugLogs'];
    
    const tableColumns = useMemo(() => {
    return [
        {
        title: translations["action"] || "Action", field: 'Action',
        hidden: visible ? visible['Action'] : false,
        filtering: false,
        render: rowData => <>
        {hasPermission(permissions, 'raspberry_erase_station_debug_log_download') ?
        
            <Tooltip title={translations['download_logs'] || 'Download logs'}> 
                <IconButton
                id={`raspberry_erase_station_debug_logs_download${rowData.DebugLogID}`}
                component='div'
                onClick={() => handleDownload(rowData.DebugLogID)}
                >
                <CloudDownloadIcon/>
                </IconButton>
            </Tooltip>
         : null}
        </>  
        },
        {
            title: translations["subject"] || 'Subject', field: 'Subject',
            hidden: visible ? visible['Subject'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Subject ? rowData.Subject : 'n/a'}</Typography>;
            }
        },
        {
            title: translations["filename"] || 'FileName', field: 'FileName',
            hidden: visible ? visible['FileName'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.FileName ? rowData.FileName : 'n/a'}</Typography>;
            }
        },
        {
            title: translations["createdAt"] || 'CreatedAt', field: 'CreatedAt',
            hidden: visible ? visible['CreatedAt'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.CreatedAt ? formatDate(rowData.CreatedAt) : 'n/a'}</Typography>;
            }
        },
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [translations, visible]);

    const handleDownload = async (debugLogID) => {
        const objectURL = `${config.backend_domain}:${config.backend_port}/raspberry-erase-station/debug-log-download?DebugLogID=${debugLogID}&ActiveCustomerID=${activeCustomerID}`;
        let exportDataSuccessful = await download(objectURL);
        tableRef.current && tableRef.current.onQueryChange();
        if(!exportDataSuccessful) {
            return snackActions.snackBarComponent(translations['download_error_msg'] || `Could not download file `, 'error');
        }
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'raspberry_erase_station_debug_log_list') ?
            <RaspberryEraseStationDebugLogsList tableColumns={tableColumns} tableRef={tableRef} /> : null}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        debugLogID: state.core.login.debugLogID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    }
}

export default connect(
    mapStateToProps,
)(withStyles(styles, { withTheme: true })(RaspberryEraseStationDebugLogs));